<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"
      @clickHandler="item.clickHandler()"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "SubscriptionListHeader",
  components: {
    HeaderValues,
  },
  data() {
    return {
      // items: [
      //   {
      //     layout: "left-side",
      //   },
      //   {
      //     title: "Subscriptions Lists",
      //     layout: "middle",
      //   },
      //   {
      //     layout: "right-side img-circle",
      //     icon: {
      //       path: "",
      //     },
      //     route: { link: "/profile-info" },
      //   },
      // ],
    }
  },

  computed: {
    profileImage() {
      return this.$store?.state?.user?.profile?.imgUrl ?? null
    },
    items() {
      return [
        {
          layout: "left-side",
          icon: {
            path: require("@/assets/logos/BackBtn@3x.png").default,
          },
          clickHandler: () => {
            this.$router.go(-1)
          },
        },
        {
          title: "Subscription Management",
          layout: "middle",
        },
        {
          layout: "right-side img-circle",
          icon: {
            path: this.profileImage,
          },
          route: { link: "/profile-info" },
        },
      ]
    },
  },

  // watch: {
  //   profileImage(value) {
  //     if (value) {
  //       this.items[2].icon.path = this.profileImage;
  //     }
  //   },
  // },
}
</script>

<style scoped lang="sass"></style>
